import * as React from 'react';
import { FileDropMulti, Input, ModalFooter } from '@moovly/ui';
import UploadFontList from '../components/UploadFontList/UploadFontList';
import { FontItem } from '../store/settings.store';
import { t } from '@moovly/i18n';

const CreateFontContainer: React.FC<{
  onCreate: (name: string, fonts: FontItem[]) => void;
  onClose: () => void;
}> = ({ onCreate, onClose }) => {
  const [fontName, setFontName] = React.useState<string>();
  const [selectFontSettings, setSelectFontSettings] = React.useState(false);
  const [fonts, setFonts] = React.useState<FontItem[]>([]);
  const uploadDisabled = React.useMemo(
    () => !fonts.length || fonts.some((font) => !font.style || !font.weight || !font.font_file),
    [fonts]
  );

  const clearFontName = React.useCallback(() => setFontName(undefined), []);
  const handleAddFonts = React.useCallback((files: File[]) => {
    setFonts((fonts) => [...fonts, ...files.map((file) => ({ weight: null, style: null, font_file: file }))]);
  }, []);
  const handleSubmitName = React.useCallback((e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSelectFontSettings(true);
  }, []);
  const handleFontItemUpdate = React.useCallback(
    (index: number, property: string, value: string) => {
      fonts[index] = { ...fonts[index], [property]: value };
      setFonts([...fonts]);
    },
    [fonts]
  );
  const handleFontDelete = React.useCallback(
    (index: number) => {
      const newFonts = [...fonts];
      newFonts.splice(index, 1);
      setFonts(newFonts);
    },
    [fonts]
  );
  const handleFontNameChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setFontName(e.target.value);
  }, []);
  const handleCreate = React.useCallback(
    (e: React.ChangeEvent<HTMLButtonElement>) => {
      e.preventDefault();
      onCreate(fontName!, fonts);
    },
    [onCreate, fontName, fonts]
  );
  return (
    <>
      {!selectFontSettings && (
        <div className="container-fluid">
          <Input
            id="font_name"
            onChange={handleFontNameChange}
            required
            className="FontModal-FontName-Input m-0 mt-4 mb-5"
            placeholder={t('fonts.create.fontName.placeholder')}
          />
          <ModalFooter
            onConfirm={handleSubmitName}
            confirmDisabled={!fontName?.length}
            onClose={onClose}
            confirmButtonText={t('fonts.create.button')}
          />
        </div>
      )}
      {selectFontSettings && (
        <>
          <h5 className="mb-4">{t('fonts.create.upload.title', { name: fontName })}</h5>
          <FileDropMulti
            label={t('fonts.create.upload.selectFonts')}
            onChange={handleAddFonts}
            accept=".ttf,.otf,.woff"
          />
          <UploadFontList onDelete={handleFontDelete} fonts={fonts} onUpdateItem={handleFontItemUpdate} />
          <ModalFooter
            onConfirm={handleCreate}
            onClose={clearFontName}
            confirmDisabled={uploadDisabled}
            confirmButtonText={t('fonts.create.upload.submit', {
              name: fontName,
            })}
            closeButtonText={t('actions.back')}
          />
        </>
      )}
    </>
  );
};
export default CreateFontContainer;
